import React from "react";
import {
  List,
  Datagrid,
  TextField,
  ReferenceField,
  DateField,
} from "react-admin";
import { makeStyles } from "@material-ui/core/styles";
import { useDataProvider } from "ra-core";

const useImageFieldStyles = makeStyles((theme) => ({
  image: {
    width: 80,
  },
}));

const ContactMessageList = (props) => {
  const dataProvider = useDataProvider();

  return (
    <List {...props}>
      <Datagrid
        rowClick={(id) => {
          dataProvider
            .update("contactMessages", {
              id,
              data: { read: true },
            })
            .then(() => {
              window.location.href = `/#/contactMessages/${id}/show`;
            });
        }}
      >
        <ReferenceField
          label="User Name"
          source="userId"
          reference="users"
          resource="users"
        >
          <TextField source="email" />
        </ReferenceField>
        <TextField source="subject" />
        <DateField source="createdAt" />
      </Datagrid>
    </List>
  );
};

export default ContactMessageList;
